import { CircularProgress, DialogActions } from "@mui/material"
import type { FC } from "react"

import { Button } from "@/components/common/Button"
import { useAppView } from "@/hooks/useAppView"

interface PutAwayModalActionsProps {
  onCancel: () => void
  onConfirm: () => void
  loading?: boolean
  confirmLabel?: string
}

export const PutAwayModalActions: FC<PutAwayModalActionsProps> = ({
  onCancel,
  onConfirm,
  loading = false,
  confirmLabel = "Finish Storing Products",
}) => {
  const { isTabletView } = useAppView()

  return (
    <DialogActions className='justify-between gap-2 px-10 py-6'>
      <Button
        appearance='outlined'
        variant='primary'
        onClick={onCancel}
        disabled={loading}
        data-testid='put-away-cancel-button'
        className={isTabletView ? "flex-1" : ""}
      >
        Cancel
      </Button>
      <Button
        appearance='contained'
        variant='primary'
        onClick={onConfirm}
        disabled={loading}
        data-testid='put-away-confirm-button'
        className={isTabletView ? "flex-1" : ""}
      >
        {loading ? <CircularProgress size={20} color='inherit' /> : confirmLabel}
      </Button>
    </DialogActions>
  )
}
